module.exports = __webpack_public_path__ + "img/lines.37900525.png";